import { useEffect, useState } from 'react';
import I18n from 'I18n';
import { canWrite } from 'documents-ui/lib/permissions';
import { isUngatedToCHIRPEndpoints } from 'documents-ui/utils/gates';
import { AutoSizedTextInput } from 'foundations-components/transitional/components/AutoSizedTextInput';
import { EditableControls } from 'foundations-components/transitional/components/EditableControls';
import { H2 } from 'foundations-components/transitional/components/H2';
import { useGetSummaryAnalytics } from '../../hooks/useGetSummaryAnalytics';
import { jsx as _jsx } from "react/jsx-runtime";
const SummaryHeaderTitle = ({
  documentId,
  documentMetadata,
  updateDocument
}) => {
  var _documentAnalyticsSum;
  const isUngatedToChirp = isUngatedToCHIRPEndpoints();
  const {
    data: documentAnalyticsSummary
  } = useGetSummaryAnalytics({
    documentId
  });
  const titleCHIRP = documentAnalyticsSummary === null || documentAnalyticsSummary === void 0 || (_documentAnalyticsSum = documentAnalyticsSummary.documentAnalyticsSummaryView) === null || _documentAnalyticsSum === void 0 ? void 0 : _documentAnalyticsSum.title;
  const titleREST = documentMetadata.get('title');
  const title = isUngatedToChirp ? titleCHIRP : titleREST;
  const [tempTitle, setTempTitle] = useState(title);
  const handleTitleChange = e => {
    setTempTitle(e.target.value);
  };
  useEffect(() => {
    // If the CHIRP title hadn't loaded when the component mounted, set the
    // temp title to the CHIRP title when it loads.
    if (isUngatedToChirp && !tempTitle && titleCHIRP) {
      setTempTitle(titleCHIRP);
    }
  }, [isUngatedToChirp, tempTitle, titleCHIRP]);
  const handleCancel = () => {
    setTempTitle(title);
  };
  const handleSave = () => {
    var _documentAnalyticsSum2;
    if ((tempTitle === null || tempTitle === void 0 ? void 0 : tempTitle.trim()) === '') {
      return handleCancel();
    }
    const folderIdREST = documentMetadata.get('folderId');
    const folderIdCHIRP =
    // Adding null as fallback because that's expected by updateDocument instead of undefined
    (documentAnalyticsSummary === null || documentAnalyticsSummary === void 0 || (_documentAnalyticsSum2 = documentAnalyticsSummary.documentAnalyticsSummaryView) === null || _documentAnalyticsSum2 === void 0 ? void 0 : _documentAnalyticsSum2.folderId) || null;
    const folderId = isUngatedToChirp ? folderIdCHIRP : folderIdREST;
    if (!documentId || !tempTitle) {
      return;
    }
    return updateDocument({
      documentId,
      folderId,
      title: tempTitle,
      isUngatedToChirp
    });
  };
  const renderTitleInput = () => {
    return /*#__PURE__*/_jsx(H2, {
      children: canWrite() ? /*#__PURE__*/_jsx(AutoSizedTextInput, {
        "data-test-id": "summary-title-text-input",
        affordance: true,
        placeholder: I18n.text('summary.header.content.titlePlaceholder'),
        readOnly: !canWrite(),
        value: tempTitle || '',
        onChange: handleTitleChange
      }) : tempTitle
    });
  };
  if (!canWrite()) {
    return renderTitleInput();
  }
  const saveDisabled = (tempTitle === null || tempTitle === void 0 ? void 0 : tempTitle.trim()) === '' || title === tempTitle;
  return /*#__PURE__*/_jsx(EditableControls, {
    "data-test-id": "summary-title-editable-controls",
    use: "flush",
    marginBlockEnd: "0",
    marginBlockStart: "0",
    onSave: handleSave,
    onCancel: handleCancel,
    saveDisabled: saveDisabled,
    children: renderTitleInput()
  });
};
export default SummaryHeaderTitle;